import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Button from '../Button';
import StandorteSection from '../components/StandorteSection';
import { Section, Container, Badge } from '../shared/ui';

const HeadBox = styled.div`
  text-align: center;
  padding: 2rem 0 0.5rem 0;
`;
const PageTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 800;
  color: var(--brand);
  margin-bottom: 1rem;
`;
const PageText = styled.p`
  max-width: 720px;
  margin: 0 auto;
  font-size: 1.12rem;
  line-height: 1.7;
  color: #3a4662;
`;
const CtaRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
`;

const Standorte: React.FC = () => (
  <>
    <Seo
      title="Standorte & Einsatzgebiete | AP Clean Services Bielefeld & Gütersloh"
      description="AP Clean Services ist in Gütersloh, Bielefeld und der gesamten Umgebung im Einsatz – von Praxis- über Büro- bis zur Grundreinigung. Jetzt kostenlose Besichtigung anfragen."
      path="/standorte"
    />
    <Section>
      <Container>
        <HeadBox>
          <Badge>Einsatzgebiet</Badge>
          <PageTitle>Unsere Standorte &amp; Einsatzgebiete</PageTitle>
          <PageText>
            Unser Firmensitz ist in Gütersloh. Von hier aus betreuen wir Kunden in Bielefeld, Gütersloh und der gesamten Umgebung – zuverlässig, mit kurzen Anfahrtswegen und persönlicher Betreuung.
          </PageText>
        </HeadBox>
        <StandorteSection showHeader={false} />
        <CtaRow>
          <Link to="/kontakt">
            <Button size="lg">Kostenlose Besichtigung anfragen</Button>
          </Link>
        </CtaRow>
      </Container>
    </Section>
  </>
);

export default Standorte;
